(() => {
  const syncVariant = select => {
    const option = select.options[select.selectedIndex];
    const scope = select.closest('[data-product-scope]');
    if (!option || !scope) return;
    const text = (selector, value) => scope.querySelectorAll(selector).forEach(el => { el.textContent = value || ''; });
    const sale = Boolean(option.dataset.compare);
    text('[data-product-price]', option.dataset.price);
    text('[data-product-compare]', option.dataset.compare);
    text('[data-shopping-installment]', option.dataset.installment);
    text('[data-shopping-saving-value]', option.dataset.saving);
    text('[data-transfer-saving]', option.dataset.transfer);
    text('[data-variant-discount]', (option.dataset.discount || '0') + '% OFF');
    scope.querySelectorAll('[data-product-compare], [data-variant-discount], [data-shopping-savings]').forEach(el => { el.hidden = !sale; });
    const available = option.dataset.available === 'true';
    const stock = scope.querySelector('[data-shopping-stock]');
    if (stock) { stock.textContent = available ? '✓ Disponible' : 'Sin stock'; stock.classList.toggle('in-stock', available); stock.classList.toggle('out-stock', !available); }
    const submit = scope.querySelector('.product-form button[type="submit"]');
    if (submit) { submit.disabled = !available; submit.textContent = available ? 'AGREGAR AL CARRITO' : 'AGOTADO'; }
  };
  document.addEventListener('change', event => {
    if (event.target.matches('.product-form [data-variant-select]')) syncVariant(event.target);
  });
  const observers = new Map();
  const init = (root = document) => {
    root.querySelectorAll('.product-form [data-variant-select]').forEach(syncVariant);
    root.querySelectorAll('[data-shopping-filters]').forEach(el => { if (!el.dataset.ready) { el.open = !window.matchMedia('(max-width: 749px)').matches; el.dataset.ready = 'true'; } });
    root.querySelectorAll('[data-shopping-product]').forEach(product => {
      if (observers.has(product) || !('IntersectionObserver' in window)) return;
      const scope = product.closest('[data-product-scope]');
      const form = product.querySelector('.product-form');
      const bar = scope?.querySelector('[data-shopping-buybar]');
      if (!form || !bar) return;
      const observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        bar.hidden = entry.isIntersecting;
      }, { rootMargin: '-80px 0px 0px 0px' });
      observer.observe(form);
      observers.set(product, observer);
    });
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('.shopping-buybar a, .shopping-delivery a');
    if (!link) return;
    const target = document.getElementById(link.hash.slice(1));
    if (!target) return;
    if (target.tagName === 'DETAILS') target.open = true;
    if (target.classList.contains('shopping-form-anchor')) target.focus({ preventScroll: true });
  });
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    observers.forEach((observer, product) => { if (event.target.contains(product)) { observer.disconnect(); observers.delete(product); } });
  });
})();
